import { useState, useCallback } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { fetchAPI } from '../../api/request';
import ConfirmDialog from './Confirm.component';
import Button from './Button.component'

const SyncButton = ({
  label,
  apiSettings,
  query,
  jwt,
  onSuccess,
  onError,
  disabled = false,
  confirmTitle = 'Confirm Sync',
  confirmMessage,
  successMessage,
  loadingMessage,
  setSuccess = () => {},
  setError = () => {},
  ...buttonProps
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);  

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    if (!loading) {
      setModalOpen(false);
    }
  };

  const handleConfirmSync = useCallback(() => {
    setLoading(true);
    setSuccess(false);
    setError(false);
    fetchAPI(
      apiSettings,
      {},
      query,
      {},
      jwt
    )
      .then(() => {
        onSuccess?.(successMessage || `${label} synchronized successfully`);
      })
      .catch(() => {
        onError();
        setLoading(false);
        setError(true);
      });
  }, [setSuccess, setError, apiSettings, query, jwt, onSuccess, successMessage, label, onError]);

  const getModalMessage = () => {
    if (loading) {
      return loadingMessage || `Synchronizing ${label?.toLowerCase()}...`;
    }
    return confirmMessage || `Are you sure you want to sync ${label?.toLowerCase()}?`;
  };

  return (
    <>
      <Button
        onClick={handleOpenModal}
        variant="contained"
        size="medium"
        disabled={disabled || loading}
        {...buttonProps}
      >
        {label}
      </Button>

      <ConfirmDialog
        open={modalOpen}
        onClose={handleCloseModal}
        title={loading ? 'Synchronizing' : confirmTitle}
        label="Sync"
        cancelAction={handleCloseModal}
        confirmAction={handleConfirmSync}
        color="primary"
        disabled={loading}
      >
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2, 
          width: '450px', 
          height: '30px' 
        }}>
          {loading && <CircularProgress size={24} />}
          <Typography>
            {getModalMessage()}
          </Typography>
        </Box>
      </ConfirmDialog>
    </>
  );
};

export default SyncButton;